export default [
  {
    id: 'key_words',
    value: 'key_words',
    name: 'Ключевые фразы (фильтрация 1С)',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Фраза',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'amendment_types',
    value: 'amendment_types',
    name: 'Типы ДС',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'object_types',
    value: 'object_types',
    name: 'Типы объектов',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'tender_type',
    value: 'tender_types',
    name: 'Типы тендеров',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'procedure_types',
    value: 'procedure_types',
    name: 'Типы запросов',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'expertise_types',
    value: 'expertise_types',
    name: 'Типы экспертиз',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      },
      {
        name: 'Короткое название',
        value: 'short_name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  // {
  //   id: 'contract_statuses',
  //   value: 'contract_statuses',
  //   name: 'Статусы договора',
  //   type: 'objectInfo',
  //   label: ['name'],
  //   attributes: [
  //     {
  //       name: 'Название',
  //       value: 'name',
  //       type: 'string'
  //     }
  //   ],
  //   required: ['name'],
  //   requests: null
  // },
  // {
  //   id: 'act_statuses',
  //   value: 'act_statuses',
  //   name: 'Статусы актов',
  //   type: 'objectInfo',
  //   label: ['name'],
  //   attributes: [
  //     {
  //       name: 'Название',
  //       value: 'name',
  //       type: 'string'
  //     }
  //   ],
  //   required: ['name'],
  //   requests: null
  // },
  // {
  //   id: 'law_statuses',
  //   value: 'law_statuses',
  //   name: 'Статусы судебных дел',
  //   type: 'objectInfo',
  //   label: ['name'],
  //   attributes: [
  //     {
  //       name: 'Название',
  //       value: 'name',
  //       type: 'string'
  //     }
  //   ],
  //   required: ['name'],
  //   requests: null
  // },
  {
    id: 'federal_districts',
    value: 'federal_districts',
    name: 'Федеральные округи',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'territory_types',
    value: 'territory_types',
    name: 'Виды территорий',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'offshore_drillings',
    value: 'offshore_drillings',
    name: 'Виды бурения в акватории',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'climate_conditions',
    value: 'climate_conditions',
    name: 'Климатические условия',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'profile_work_regions',
    value: 'profile_work_regions',
    name: 'Регионы выполнения работ (профильные)',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'job_types',
    value: 'job_type',
    name: 'Виды работ (основной договор)',
    type: 'page',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      },
      {
        name: 'Полное название',
        value: 'full_name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'contragent_job_types',
    value: 'contragent_job_type',
    name: 'Виды работ (подрядчики)',
    type: 'page',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'planer_types',
    value: 'planer_types',
    name: 'Тип проектировщика',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'project_stages',
    value: 'project_stages',
    name: 'Стадии проектирования',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'responsibility_levels',
    value: 'responsibility_levels',
    name: 'Уровни ответственности сооружений',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'company_groups',
    value: 'company_groups',
    name: 'Группы компаний',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'other_company',
    value: 'other_company',
    name: 'Компании - контрагенты',
    type: 'page',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      },
      {
        name: 'Полное название',
        value: 'full_name',
        type: 'string'
      },
      {
        name: 'ИНН',
        value: 'inn',
        type: 'string'
      },
      {
        name: 'КПП',
        value: 'kpp',
        type: 'string'
      },
      {
        name: 'Эл. почта',
        value: 'email',
        type: 'string'
      },
      {
        name: 'Телефон',
        value: 'phone',
        type: 'string'
      },
      {
        name: 'Адрес',
        value: 'address',
        type: 'string'
      },
      {
        name: 'Должность главы компании',
        value: 'head_position',
        type: 'string'
      },
      {
        name: 'ФИО главы компании',
        value: 'head_fio',
        type: 'string'
      },
      {
        name: 'Группа компаний',
        value: 'company_group_id',
        type: 'select',
        source: 'company_groups'
      }
    ],
    required: ['name'],
    requests: [{ type: 'objectInfo', name: 'company_groups' }]
  },
  {
    id: 'own_company',
    value: 'own_company',
    name: 'Компании',
    type: 'page',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      },
      {
        name: 'ИНН',
        value: 'inn',
        type: 'string'
      },
      {
        name: 'КПП',
        value: 'kpp',
        type: 'string'
      },
      {
        name: 'Группа компаний',
        value: 'company_group_id',
        type: 'select',
        source: 'company_groups'
      }
    ],
    required: ['name'],
    requests: [{ type: 'objectInfo', name: 'company_groups' }]
  },
  // {
  //   id: 'departments',
  //   value: 'departments',
  //   name: 'Отделы',
  //   type: 'objectInfo',
  //   label: ['name'],
  //   attributes: [
  //     {
  //       name: 'Название',
  //       value: 'name',
  //       type: 'string'
  //     }
  //   ],
  //   required: ['name'],
  //   requests: null
  // },
  {
    id: 'positions',
    value: 'positions',
    name: 'Должности',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      },
      {
        name: 'Отправлять отчеты на почту',
        value: 'email_notifications',
        type: 'boolean'
      }
    ],
    required: ['name'],
    requests: null
  },
  {
    id: 'users',
    value: 'users',
    name: 'Сотрудники',
    url: 'page/user',
    type: 'objectInfo',
    label: ['last_name', 'first_name'],
    createDisabled: true,
    deleteDisabled: true,
    attributes: [
      {
        name: 'Фамилия',
        value: 'last_name',
        type: 'string'
      },
      {
        name: 'Имя',
        value: 'first_name',
        type: 'string'
      },
      {
        name: 'Отчество',
        value: 'middle_name',
        type: 'string'
      },
      {
        name: 'Логин',
        value: 'username',
        type: 'string',
        disabled: true
      },
      // {
      //   name: 'Пароль',
      //   value: 'password',
      //   type: 'password'
      // },
      {
        name: 'Эл. почта',
        value: 'email',
        type: 'string',
        disabled: true
      },
      {
        name: 'Телефон',
        value: 'phone',
        type: 'phone'
      },
      {
        name: 'Компании',
        value: 'companies',
        type: 'select',
        selectType: 'multiple',
        source: 'own_company'
      },
      // {
      //   name: 'Отдел',
      //   value: 'department_id',
      //   type: 'select',
      //   source: 'departments'
      // },
      {
        name: 'Должность',
        value: 'position_id',
        type: 'select',
        source: 'positions'
      },
      {
        name: 'Статус доступа',
        value: 'role_status',
        type: 'select',
        source: 'role_statuses'
      }
    ],
    required: [
      'last_name',
      'first_name',
      'username',
      'email',
      'companies',
      'position_id',
      'role_status'
    ],
    requests: [
      { type: 'page', name: 'own_company' },
      { type: 'objectInfo', name: 'positions' }
      // { type: 'objectInfo', name: 'departments' }
    ]
  },
  {
    id: 'field_managers',
    value: 'field_managers',
    name: 'Полевые ГИПы',
    type: 'objectInfo',
    label: ['last_name', 'first_name'],
    attributes: [
      {
        name: 'Фамилия',
        value: 'last_name',
        type: 'string'
      },
      {
        name: 'Имя',
        value: 'first_name',
        type: 'string'
      },
      {
        name: 'Отчество',
        value: 'middle_name',
        type: 'string'
      }
    ],
    required: ['last_name', 'first_name']
  },
  {
    id: 'bg_types',
    value: 'bg_types',
    name: 'Типы БГ',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name']
  },
  {
    id: 'banks',
    value: 'banks',
    name: 'Банки',
    type: 'objectInfo',
    label: ['name'],
    attributes: [
      {
        name: 'Название',
        value: 'name',
        type: 'string'
      }
    ],
    required: ['name']
  }
  // {
  //   id: 'file_types',
  //   value: 'file_types',
  //   name: 'Типы файлов',
  //   type: 'objectInfo',
  //   label: ['name'],
  //   attributes: [
  //     {
  //       name: 'Название',
  //       value: 'name',
  //       type: 'string'
  //     }
  //   ],
  //   required: ['name'],
  //   requests: null
  // }
]
